import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/authService';
import { useToastStore } from '../store/toastStore';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { FormField } from '../components/ui/FormField';

export function ForgotPasswordPage() {
  const showToast = useToastStore((s) => s.show);

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (err: unknown) {
      const axiosErr = err as { response?: { data?: { errors?: string[] } } };
      showToast(axiosErr?.response?.data?.errors?.[0] ?? 'Erro ao enviar o link. Tente novamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-sm p-8 w-full max-w-sm">
        <h1 className="text-2xl font-bold text-text-dark mb-1">Esqueci minha senha</h1>
        <p className="text-text-light text-sm mb-6">
          Informe seu e-mail para receber o link de redefinição
        </p>

        {sent ? (
          <div className="flex flex-col gap-4">
            <p className="text-olivine font-medium text-sm">
              Link enviado! Verifique seu e-mail.
            </p>
            <Link
              to="/login"
              className="text-chocolate hover:underline text-sm text-center"
            >
              Voltar para o login
            </Link>
          </div>
        ) : (
          <>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <FormField label="E-mail" required>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="exemplo@email.com"
                  required
                />
              </FormField>

              <Button type="submit" fullWidth loading={loading}>
                Enviar link
              </Button>
            </form>

            <p className="text-center text-sm text-text-light mt-4">
              Lembrou a senha?{' '}
              <Link to="/login" className="text-chocolate hover:underline">
                Entrar
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
